// extracted by mini-css-extract-plugin
export var agendaSection = "agenda-block-module--agendaSection--90334";
export var items = "agenda-block-module--items--c243a";
export var tabOpen = "agenda-block-module--tabOpen--a3371";
export var tabs = "agenda-block-module--tabs--3aff5";